import React from "react";
import TextField from "@mui/material/TextField";
import { Button, } from "@mui/material";
import { Link } from "react-router-dom";
import "./SignUp.css";
import { useSignup } from "../../../Hooks/Auth/useSignup";
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



function SignUp() {
  const location = useLocation().state
  const { signupdata, setsignupdata, error, handleSubmit, setError, handleValidation, captcha, setcaptcha, imageSrc, imageRef, fetchCaptcha } = useSignup();

  return (
    <div className="insights-login-container">
      <div className="insights-data-container"></div>
      <div className="insights-login-data-container">
        <div className="insights-login-info">
          <img
            src="./assets/logo.png"
            alt="srkay-logo"
            className="srkay-logo"
          />
          {
            location?.key === "is_forgot" ? <h3>Forgot Your Password</h3> : <><h3>Welcome!</h3>
              <h6>Sign Up...</h6></>
          }
          <form className="login-section" onSubmit={handleSubmit}>
            <div className="login-input">
              <TextField
                onBlur={(e) => handleValidation('sign_up', e.target.value, setError)}
                value={signupdata}
                onChange={(e) => { setsignupdata(e.target.value); setError((prevState) => ({ ...prevState, user_loginname: '' })); }}
                label="Employee Code/E-mail"
                variant="standard"
                size="small"
                style={{ width: "100%" }}
                name="signupdata"
                className="mx-0"
              />
            </div>
            {error?.user_loginname && (
              <p className="text-danger text-left font-weight-bold mx-2">
                {error?.user_loginname}
              </p>
            )}
            <div className="login-input">
              <TextField
                label="Enter CAPTCHA"
                variant="standard"
                size="small"
                width='100'
                value={captcha.captchaCode}
                onChange={(e) => {
                  setcaptcha((prevState) => ({ ...prevState, captchaCode: e.target.value }))
                  setError((prevState) => ({ ...prevState, captcha: '' }))
                }}
                fullWidth
                className="mx-0"
              />  </div>
            {error?.captcha && (
              <p className="text-danger text-left font-weight-bold mx-2">
                {error?.captcha}
              </p>
            )}
            <div className="captcha-container" >
              <div className="captcha-display">
                <div>
                  {imageSrc ? (
                    <img id="output" ref={imageRef} alt="output" style={{ height: "57px" }} />
                  ) : (
                    <p>Loading image...</p>
                  )}
                </div>
              </div>
              <div style={{ cursor: 'pointer' }} onClick={() => {
                fetchCaptcha()
                setcaptcha({
                  captchaCode: '',
                  captchaId: ""
                })
              }}><FontAwesomeIcon icon="fa fa-refresh" /></div>
            </div>
            {error?.apiError && (
              <p className="text-danger text-left font-weight-bold mx-2">
                {error?.apiError}
              </p>
            )}
            <Button type="submit" variant="contained" className="login-button" >
              {location?.key === "is_forgot" ? "Forgot Passsword" : "Sign Up"}
            </Button>
            {/* Sign In Link */}
            <div className="sign-up">
              {location?.key !== "is_forgot" ?
                <p>
                  Already have an account?{" "}
                  <Link
                    to="/sign-in"
                    className="sign-in"
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Sign In
                  </Link>
                </p> : <p>Back to <Link className="sign-in" to="/sign-in" > Sign In</Link></p>}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
